import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=23eaee5d&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "styles/components/bottomfooter.css?vue&type=style&index=0&id=23eaee5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eaee5d",
  null
  
)

export default component.exports